import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from "@mui/material";
import { baseURL } from "../../api";
import axios from "axios";
import { Global_Data } from "../../globalData/GlobalData";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

function DocumentSelect({
  data,
  renderComponent,
  selectedRowsDataGrid,
  setselectedRowsDataGrid,
  setdocumentSelectTableData,
  setdocumentSelectmappingData,
  setDocumentSelectKey,
  setDocumentSelectMainRecordData,
  setDocumentSelectMainRecordObject,
  setIsDocumentSelect
}) {
  const [mainFormData, setMainFormData] = useState({});
  const [tableRecordData, settableRecordData] = useState([]);
  const [prevSelectedCustomer, setPrevSelectedCustomer] = useState("");
  const [sourceHydration, setSourceHydration] = useState({
    status: "idle",
    selectionIdentity: ""
  });
  const requestSequenceRef = useRef(0);
  const activeRequestControllerRef = useRef(null);
  const { loading, trackRequest } = usePendingRequests();
  const { token, setTextValue, openDocumentSelect, setOpenDocumentSelect,multiDocumentSelectData,
    setMultiDocumentSelectData,setmultiDocumentSelectDataForTable, textValue } = Global_Data();

  const resetSourceHydration = ({ clearPublishedData = true } = {}) => {
    requestSequenceRef.current += 1;
    activeRequestControllerRef.current?.abort();
    activeRequestControllerRef.current = null;
    setMainFormData({});
    settableRecordData([]);
    setSourceHydration({ status: "idle", selectionIdentity: "" });

    if (clearPublishedData) {
      setDocumentSelectMainRecordData("");
      setDocumentSelectMainRecordObject("");
    }
  };

  const handleClickOpen = () => {
    resetSourceHydration();
    setselectedRowsDataGrid([]);
    setPrevSelectedCustomer(textValue["select_customer"]);
    setTextValue((prev) => ({...prev, ["select_customer"]: ""}))
    setOpenDocumentSelect(true);
  };

  const handleClose = () => {
    resetSourceHydration();
    setTextValue((prev) => ({...prev, ["select_customer"]: prevSelectedCustomer}));
    setOpenDocumentSelect(false);
    setselectedRowsDataGrid([]);
  };

  const selectedDocument = selectedRowsDataGrid?.[0];
  const selectedDocumentIdentity = selectedDocument && data?.data?.sDataSource
    ? replaceUriPlaceholders(selectedDocument, data.data.sDataSource)
    : "";
  const isMultiSelect = data?.component?.options?.submode == "MULTISELECT";
  const sourceTableFieldName =
    data?.data?.mapping?.tablerecord?.[0]?.tablenameSource?.replace(/[{}]/g, "");
  const selectedSourceTableName = selectedDocument?.[sourceTableFieldName];
  const selectedTableRecordData = tableRecordData.filter(
    record => record.sInputTableName == selectedSourceTableName
  );
  const sourceDataReady =
    sourceHydration.status === "ready" &&
    sourceHydration.selectionIdentity === selectedDocumentIdentity &&
    mainFormData &&
    typeof mainFormData === "object" &&
    !Array.isArray(mainFormData) &&
    Object.keys(mainFormData).length > 0 &&
    Array.isArray(tableRecordData) &&
    Boolean(selectedSourceTableName) &&
    selectedTableRecordData.length > 0;
  const confirmDisabled =
    loading ||
    !selectedDocument ||
    (!isMultiSelect && !sourceDataReady);

  const handleConfirm = () => {
    if (confirmDisabled) return;

    if (isMultiSelect) {
    setmultiDocumentSelectDataForTable(multiDocumentSelectData)
    setOpenDocumentSelect(false);
    setMultiDocumentSelectData([])
    } else {
      const newTable = selectedTableRecordData.map(record => ({
        ...record,
        mappingTableName: data?.data?.mapping?.tablerecord[0]?.tablenameDestination
      }));
      setdocumentSelectTableData(newTable);
      const obj = {};
      for (let i = 0; i < data?.data?.mapping?.tablerecord[0]?.mapping.length; i++) {
        const element = data?.data?.mapping?.tablerecord[0]?.mapping[i];
        obj[element.destinationColumn] = element.sourceXPath.split(".")[1];
      }
      setdocumentSelectmappingData(obj);
      setDocumentSelectKey((prev) => {
        if(prev == ""){
          return 1;
        } else {
          return prev + 1;
        }
      });
      const mappedMainRecord = transformFields(
        data.data.mapping.mainrecord,
        mainFormData
      );

      /*
       * Identify this main-record update as one DocumentSelect hydration cycle.
       * Dependent controls use the mapped values to avoid replacing an
       * authoritative Load From value with their normal cascade default.
       */
      setIsDocumentSelect(previous => ({
        cycle:
          previous && typeof previous === "object"
            ? (previous.cycle || 0) + 1
            : 1,
        values: mappedMainRecord
      }));

      setTextValue(pre => ({
        ...pre,
        ...mappedMainRecord
      }));

      resetSourceHydration({ clearPublishedData: false });
      setOpenDocumentSelect(false);
      setselectedRowsDataGrid([]);
    }
  };

  function replaceUriPlaceholders(data, uri) {
    return uri.replace(/{([^}]+)}/g, (match, key) => {
      return key in data ? data[key] : match;
    });
  }
  useEffect(() => {
    if (isMultiSelect || !openDocumentSelect || !selectedDocumentIdentity) {
      resetSourceHydration();
      return;
    }

    const requestSequence = requestSequenceRef.current + 1;
    requestSequenceRef.current = requestSequence;
    activeRequestControllerRef.current?.abort();
    const controller = new AbortController();
    activeRequestControllerRef.current = controller;

    setMainFormData({});
    settableRecordData([]);
    setDocumentSelectMainRecordData("");
    setDocumentSelectMainRecordObject("");
    setSourceHydration({
      status: "loading",
      selectionIdentity: selectedDocumentIdentity
    });

    const fetchSelectedDocument = async () => {
      try {
        const response = await trackRequest(() =>
          axios.get(baseURL + selectedDocumentIdentity, {
            headers: {
              Authorization: `Bearer ${token}`
            },
            signal: controller.signal
          })
        );

        if (
          controller.signal.aborted ||
          requestSequenceRef.current !== requestSequence
        ) {
          return;
        }

        const responseData = response?.data?.data;
        const responseMainRecord = responseData?.mainrecord;
        const responseTableRecords = responseData?.tablerecords;
        const validMainRecord =
          responseMainRecord &&
          typeof responseMainRecord === "object" &&
          !Array.isArray(responseMainRecord) &&
          Object.keys(responseMainRecord).length > 0;

        if (!validMainRecord || !Array.isArray(responseTableRecords)) {
          throw new Error("Selected document response is incomplete.");
        }

        const containsSelectedTable = responseTableRecords.some(
          record => record.sInputTableName == selectedSourceTableName
        );
        if (!selectedSourceTableName || !containsSelectedTable) {
          throw new Error("Selected document details are incomplete.");
        }

        setDocumentSelectMainRecordData(
          responseMainRecord[selectedSourceTableName]
        );
        setDocumentSelectMainRecordObject(responseMainRecord);
        setMainFormData(responseMainRecord);
        settableRecordData(responseTableRecords);
        setSourceHydration({
          status: "ready",
          selectionIdentity: selectedDocumentIdentity
        });
      } catch (error) {
        if (
          controller.signal.aborted ||
          requestSequenceRef.current !== requestSequence ||
          axios.isCancel(error)
        ) {
          return;
        }

        setMainFormData({});
        settableRecordData([]);
        setDocumentSelectMainRecordData("");
        setDocumentSelectMainRecordObject("");
        setSourceHydration({
          status: "error",
          selectionIdentity: selectedDocumentIdentity
        });
        console.error("Unable to hydrate selected document:", error);
      } finally {
        if (activeRequestControllerRef.current === controller) {
          activeRequestControllerRef.current = null;
        }
      }
    };

    fetchSelectedDocument();

    return () => {
      controller.abort();
    };
  }, [
    isMultiSelect,
    openDocumentSelect,
    selectedDocumentIdentity,
    selectedSourceTableName,
    token,
    trackRequest
  ]);

  function transformFields(fields, mainBackend) {
    let result = {};

    fields.forEach(field => {
      const { sourceXPath, destinationComponent } = field;
      if (mainBackend.hasOwnProperty(sourceXPath)) {
        result[destinationComponent] = mainBackend[sourceXPath];
      }
    });

    return result;
  }

  return (
    <>      
      <Grid item {...data.component.sButton.grid_props}>
        <Button 
          {...data.component.sButton.sButtonProps} 
          sx={{...data.component.sButton.sButtonProps}} 
          onClick={handleClickOpen}
          id={`${data?.component?.sName}_button`}
        >
          {data.component.sButton.sButtonLabel}
        </Button>
      </Grid>
      <Dialog open={openDocumentSelect} {...data?.component?.sDialog?.sDialogProps}>
        <DialogTitle>{data.component.sDialog.sTitle}</DialogTitle>
        <DialogContent>
          <ComponentLoadingBoundary
            loading={loading}
            label="Loading selected document"
            minHeight={120}
            size={28}
          >
            {renderComponent(data.child)}
          </ComponentLoadingBoundary>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={()=>handleConfirm()}
            {...data?.component?.sActionButton?.sConfirm.sButtonProps}
            disabled={confirmDisabled}
            id={`${data?.component?.sActionButton?.sConfirm?.sButtonName}`}
          >
            {data?.component?.sActionButton?.sConfirm?.sButtonLabel}
          </Button>
          <Button 
            onClick={()=>handleClose()} 
            {...data?.component?.sActionButton?.sCancel?.sButtonProps}
            id={`${data?.component?.sActionButton?.sCancel?.sButtonName}`}
          >
            {data?.component?.sActionButton?.sCancel?.sButtonLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DocumentSelect;
